import "../styles/Nav.css";
import Logo from "../images/logo.png"

export default function Nav({ page, setPage }) {
  const links = ["home", "about", "gallery", "shop", "classroom", "feedback", "faq" ];

  return (
    <nav className="nav">
      <div className="nav-logo" onClick={() => setPage("home")}>
        <img src={Logo} alt="DSON Art Logo" className="nav-logo-img" />
      </div>

      <div className="nav-links">
        {links.map((l) => (
          <div
            key={l}
            className={`nav-link${page === l ? " active" : ""}`}
            onClick={() => setPage(l)}
          >
            {l.charAt(0).toUpperCase() + l.slice(1)}
          </div>
        ))}
        <div
          className={`nav-link admin-link${page === "admin" ? " active" : ""}`}
          onClick={() => setPage("admin")}
        >
          Admin
        </div>
      </div>
    </nav>
  );
}
